// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__OJJB_","clinicsSelect":"TableHeading_clinicsSelect__2o2YJ"};